import { KeyboardEvent } from 'react'
import { useEventListener } from 'react-nb-hooks'

function useCapsLock(on: boolean, onChange: (isOn: boolean) => void) {
  useEventListener('keydown', (event: any) => {
    if (typeof event.getModifierState !== 'function') {
      return
    }

    const isCapsLockOn = event.getModifierState('CapsLock')

    if (on !== isCapsLockOn) {
      onChange(isCapsLockOn)
    }
  })
}

const CapsLockStateProvider = ({ on, onChange }) => {
  useCapsLock(on, onChange)

  return null
}

export default CapsLockStateProvider
